import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../services/session.service';

/**
 * Guard para rutas de invitado (login, register).
 * Si el usuario ya tiene sesión activa, lo redirige a su dashboard correspondiente.
 */
export const GuestGuard: CanActivateFn = () => {
  const sessionService = inject(SessionService);
  const router = inject(Router);

  const session = sessionService.getCurrentSession();

  if (session.isAuthenticated && session.user) {
    const userType = session.user.userType?.toLowerCase();
    if (userType === 'abogado') {
      return router.createUrlTree(['/abogado/dashboard']);
    } else if (userType === 'cliente') {
      return router.createUrlTree(['/cliente/dashboard']);
    }
    return router.createUrlTree(['/']);
  }

  return true;
};
